/**
 * Valori dei campi del giocatore (V36, V41), fuori dal file del componente
 * perche il ricaricamento a caldo vuole file che esportano solo componenti.
 */

import type { Giocatore } from './elenchi.js';

export interface ValoriAnagrafica {
  nome: string;
  cognome: string;
  dataNascita: string;
}

/** Ruolo e piede: vuoti solo nel nuovo giocatore, finche non si sceglie. */
export interface ValoriCampo {
  ruoloPreferito: string;
  piede: string;
}

export const valoriDa = (
  g?: Pick<Giocatore, 'nome' | 'cognome' | 'dataNascita'>,
): ValoriAnagrafica => ({
  nome: g?.nome ?? '',
  cognome: g?.cognome ?? '',
  dataNascita: g?.dataNascita ?? '',
});

export const valoriCampoDa = (g?: Pick<Giocatore, 'ruoloPreferito' | 'piede'>): ValoriCampo => ({
  ruoloPreferito: g?.ruoloPreferito ?? '',
  piede: g?.piede ?? '',
});
